import { Box, Divider, useTheme } from '@mui/material';

const Dot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <circle cx="4" cy="4" r="3" stroke="#4A148C" strokeWidth="2" />
  </svg>
);

export type StopsIndicatorProps = {
  stops?: number;
};

export const StopsIndicator = ({ stops = 0 }: StopsIndicatorProps) => {
  const theme = useTheme();

  const dotit = () => {
    const dots = [];

    for (let i = 0; i < stops; i++) {
      dots.push(
        <Box
          key={i}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ width: '8px', height: '8px', backgroundColor: '#ffffff', borderRadius: '50%', zIndex: 2 }}
        >
          <Dot />
        </Box>,
      );
    }

    return dots;
  };

  return (
    <Box
      minWidth="80px"
      minHeight="8px"
      position="relative"
      display="flex"
      justifyContent="space-evenly"
      sx={{ width: '100%' }}
    >
      <Divider
        sx={{
          position: 'absolute',
          color: theme.palette.primary.main,
          background: theme.palette.primary.main,
          width: '100%',
          marginY: 1,
          top: `calc(50% - ${theme.spacing(1)})`,
          zIndex: 1,
        }}
      />
      {dotit()}
    </Box>
  );
};
